export const fileFields = {
  ID: 'id',
  PATH: 'path',
  NAME: 'fileName',
};

export const FILE_URL = '/api/v1/file';
